import React from "react";
import { AuthConsumer } from "./authProvider";
export const SilentRenew =  () => (
    <AuthConsumer>
        {  ({ signinSilentCallback }) => {
            signinSilentCallback()
            return <span>loading</span>;
        }}  
    </AuthConsumer>
);